module.exports = __webpack_public_path__ + "static/img/banner.2952f42c.png";